<template>
  <div class="timeslice" ref="timeslice">
<!--    <button @click="undo">Undo</button>-->
<!--    <button @click="clear">Clear</button>-->
  </div>
</template>

<script>
  import * as THREE from 'three';

  import * as TimesliceExample1 from '../services/3d/timesliceExample1'
  import {createExampleBg, createThreeBgScene} from "../services/3d/timesliceBg";
  import {initializeTimeslice, initializeTimesliceTest, loadArrow} from "../services/3d/timesliceUtils";
  import {initializeDrawing} from "../services/3d/timesliceDraw";
  import {addArrow} from "../services/3d/timesliceArrows";


  export default {
    name: 'TimeSlice',
    data: () => ({
      drawingsArray: null,
      drawScene: null
    }),

    methods: {
      undo() {
        let drawingToRemove = this.drawingsArray.pop();
        this.drawScene.remove(drawingToRemove)
      },
      clear() {
        while(this.drawingsArray.length) {
          this.undo()
        }
      }
    },

    mounted() {
      let timesliceData = {
        backgroundImage: "https://s3.us-west-1.amazonaws.com/statics.vision.remotepc.com/app/timeslice/2019/12/2aa330cd-b3bb-4b99-9fa4-fd9838ea30bf.jpg",
        callSid: "c265eb9b-ec26-4007-be45-ce2e11e055c1",
        height: 414,
        projectionCameraMatrix: "simd_float4x4([[1.5559946, 0.0, 0.0, 0.0], [0.0, 3.3675632, 0.0, 0.0], [-0.0029268265, -0.058438063, -1.000001, -1.0], [0.0, 0.0, -0.001000001, 0.0]])",
        transformCameraMatrix: "simd_float4x4([[0.9819749, -0.025180152, 0.1873265, 0.0], [0.093410484, 0.9262474, -0.36515757, 0.0], [-0.16431598, 0.37607384, 0.911904, 0.0], [0.014722746, 0.06216345, 0.035554614, 0.99999994]])",
        width: 896
      };

      Promise.all([
        initializeTimeslice(timesliceData, this.$refs.timeslice),//v896, 414,
        // createThreeBgScene(timesliceData.backgroundImage, timesliceData.width/timesliceData.height),
        loadArrow()
      ])
        .then(([
          {renderer, camera, scene, debugCamera, debugControls},
          arrow
        ]) => {

          let {drawCamera, drawScene, drawingsArray} = initializeDrawing(renderer, []);
          this.drawingsArray = drawingsArray;
          this.drawScene = drawScene;

          let arrow1 = addArrow(arrow, TimesliceExample1.arrow3, 10,  TimesliceExample1.transformCameraMatrix);
          let arrow2 = addArrow(arrow, TimesliceExample1.arrow4, 4,  TimesliceExample1.transformCameraMatrix);
          scene.add(arrow1);
          scene.add(arrow2);

          let helper = new THREE.CameraHelper( drawCamera );
          scene.add( helper ) ;


          let animate = function () {
            requestAnimationFrame(animate);

            debugControls.update();
            renderer.clear();
            // renderer.render(backgroundScene, backgroundCamera);
            renderer.render(scene, debugCamera);
            // renderer.render(drawScene, drawCamera);
          };

          animate()

      });

    }
  }
</script>

<style lang="scss">

</style>
